<template>
  <div class="container-fluid">
    <titular />
    <ul class="list-inline">
      <li class="list-inline-item">
        <modal ref="modalCreacionMultiple" titulo="Afegir despeses" icono="fa-solid fa-list-check" :loading="loading.creacionMultiple" @abrir="abrirModal('autofocusCreacionMultiple')" @cerrar="cerrarCreacion">
          <template v-slot:body>
            <form id="form-creacion-multiple" autocomplete="off" @submit.prevent="crearMultiple">
              <div class="form-group w-50">
                <label for="nuevo-data_despesa">Data</label>
                <input ref="autofocusCreacionMultiple" type="date" class="form-control" id="nuevo-data_despesa" v-model="nuevos.gasto.data_despesa" :disabled="loading.creacionMultiple" :min="minFecha" :max="maxFecha" required />
              </div>
              <div class="form-group">
                <label for="nuevo-proveidor">Proveïdor</label>
                <input type="text" class="form-control" id="nuevo-proveidor" v-model="nuevos.gasto.proveidor" :disabled="loading.creacionMultiple" maxlength="255" required />
              </div>
              <div class="form-group">
                <label for="nuevo-concepte">Concepte</label>
                <input type="text" class="form-control" id="nuevo-concepte" v-model="nuevos.gasto.concepte" :disabled="loading.creacionMultiple" required />
              </div>
              <div class="form-group">
                <label for="nuevo-import">Import</label>
                <div class="input-group w-50">
                  <input type="number" step="0.01" class="form-control text-right" id="nuevo-import" v-model="nuevos.gasto.import" :disabled="loading.creacionMultiple" min="0" max="99999.99" required />
                  <div class="input-group-append">
                    <span class="input-group-text">€</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-proyecto">Projecte</label>
                <select class="form-control" id="nuevo-proyecto" v-model="nuevos.gasto.id_projecte" :disabled="loading.creacionMultiple" required>
                  <option v-for="(proyecto, index) in proyectos" :key="index" :value="proyecto.id">{{ proyecto.cliente }} → {{ proyecto.titol }}</option>
                </select>
              </div>
            </form>
          </template>
          <template v-slot:footer>
            <button type="submit" class="btn btn-primary" form="form-creacion-multiple" :disabled="loading.creacionMultiple"><i-submit icono="fa-list-check" :loading="loading.creacionMultiple" />Continuar</button>
          </template>
        </modal>
      </li>
    </ul>
    <div class="row mb-5">
      <div class="col">
        <rangofechas :rangoMax="maxFecha" @buscar="getData" />
      </div>
    </div>
    <vue-bootstrap4-table id="tabla" ref="tabla" :rows="rows" :columns="columns" :classes="classes" :config="config" :actions="actionsExportar" @exportarTabla="exportarTablaPrevio" @exportarBolcat="exportarBolcatPrevio">
      <template slot="empty-results">No hi ha cap despesa</template>
      <template slot="global-search-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="sort-asc-icon">
        <i class="fa-solid fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa-solid fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fas fa-sort"></i>
      </template>
      <template slot="simple-filter-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="paginataion-previous-button">
        <i class="fa-solid fa-angle-left"></i>
      </template>
      <template slot="paginataion-next-button">
        <i class="fa-solid fa-angle-right"></i>
      </template>
      <template v-slot:pagination-info="props">
        Registres: {{ props.currentPageRowsLength }} de {{ props.filteredRowsLength }}<template v-if="props.filteredRowsLength !== props.originalRowsLength"> ({{ props.originalRowsLength }} en total)</template>
      </template>
      <template slot="selected-rows-info" slot-scope="props">{{ props }} Selecció: {{ props.selectedItemsCount }}</template>
      <template slot="acciones" slot-scope="props">
        <div class="btn-group btn-group-sm" role="group" aria-label="Accions">
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-editar-${props.row.id}`" title="Editar despesa" v-tooltip><i class="fa-solid fa-pen-to-square"></i></button>
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-eliminar-${props.row.id}`" title="Eliminar despesa" v-tooltip><i class="fa-solid fa-trash-can"></i></button>
        </div>
        <div class="text-left">
          <modal :ref="`modalEdicion${props.row.id}`" titulo="Editar despesa" icono="fa-solid fa-pen-to-square" btnClass="btn-secondary" :hayLanzador="false" :modalId="`editar-${props.row.id}`" :loading="loading.edicion" @abrir="abrirModal(`autofocusEdicion${props.row.id}`)" @cerrar="cerrarEdicion">
            <template v-slot:body>
              <form :id="`form-edicion${props.row.id}`" autocomplete="off" @submit.prevent="editar(props.row.id)">
                <div class="form-group w-50">
                  <label :for="`data_despesa${props.row.id}`">Data</label>
                  <input :ref="`autofocusEdicion${props.row.id}`" type="date" class="form-control" :id="`data_despesa${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).data_despesa" :disabled="loading.edicion" :min="getMinFecha(getRowId(props.row.id, rows).data_despesa)" :max="maxFecha" required />
                </div>
                <div class="form-group">
                  <label :for="`proveidor${props.row.id}`">Proveïdor</label>
                  <input type="text" class="form-control" :id="`proveidor${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).proveidor" :disabled="loading.edicion" maxlength="255" required />
                </div>
                <div class="form-group">
                  <label :for="`concepte${props.row.id}`">Concepte</label>
                  <input type="text" class="form-control" :id="`concepte${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).concepte" :disabled="loading.edicion" required />
                </div>
                <div class="form-group">
                  <label :for="`import${props.row.id}`">Import</label>
                  <div class="input-group w-50">
                    <input type="number" step="0.01" class="form-control text-right" :id="`import${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).import" :disabled="loading.edicion" min="0" max="99999.99" required />
                    <div class="input-group-append">
                      <span class="input-group-text">€</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`projecte${props.row.id}`">Projecte</label>
                  <select class="form-control" :id="`cliente${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).id_projecte" :disabled="loading.edicion" required>
                    <option v-for="(proyecto, index) in proyectos" :key="index" :value="proyecto.id">{{ proyecto.cliente }} → {{ proyecto.titol }}</option>
                  </select>
                </div>
              </form>
            </template>
            <template v-slot:footer>
              <button type="submit" class="btn btn-primary" :disabled="loading.edicion" :form="`form-edicion${props.row.id}`"><i-submit icono="fa-pen-to-square" :loading="loading.edicion" />Confirmar</button>
            </template>
          </modal>
          <modal :ref="`modalEliminacion${props.row.id}`" titulo="Eliminar despesa" icono="fa-solid fa-trash-can" btnClass="btn-secondary" :hayLanzador="false" :modalId="`eliminar-${props.row.id}`" :loading="loading.eliminacion" @abrir="abrirModal(`autofocusEliminacion${props.row.id}`)" @cerrar="cerrarEliminacion">
            <template v-slot:body>
              <div class="alert alert-warning" role="alert"><i class="fa-solid fa-triangle-exclamation mr-1"></i>Aquesta acció no es pot desfer.</div>
              Vols eliminar la despesa #<b>{{ props.row.id }}</b>?
            </template>
            <template v-slot:footer>
              <button :ref="`autofocusEliminacion${props.row.id}`" type="submit" class="btn btn-danger" :disabled="loading.eliminacion" @click="eliminar(props.row.id)"><i-submit icono="fa-trash-can" :loading="loading.eliminacion" />Confirmar</button>
            </template>
          </modal>
        </div>
      </template>
      <template slot="data_despesa_cell" slot-scope="props">
        {{ props.row.data_despesa_format }}
      </template>
      <template slot="import" slot-scope="props"> {{ formatearDecimales(props.cell_value) }}€ </template>
    </vue-bootstrap4-table>
  </div>
</template>

<style lang="scss">
#tabla {
  .vbt-refresh-button {
    display: none;
  }
}
</style>

<script>
import rangofechas from "@/components/RangoFechas.vue"

export default {
  name: "Despeses",
  inject: ["formatearDecimales", "exportarTabla", "exportarBolcat", "actionsExportar", "formatearFecha"],
  components: {
    rangofechas,
  },
  data() {
    return {
      loading: {
        creacion: false,
        creacionMultiple: false,
        edicion: false,
        eliminacion: false,
      },
      rows: [],
      rowsBuffer: [],
      columns: [
        {
          label: "#",
          name: "id",
          filter: {
            type: "simple",
            placeholder: "Filtra ID",
          },
          sort: true,
          initial_sort: true,
          initial_sort_order: "desc",
          row_text_alignment: "text-left",
        },
        {
          label: "Data",
          name: "data_despesa_cell",
          filter: {
            type: "simple",
            placeholder: "Filtra data",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Proveïdor",
          name: "proveidor",
          filter: {
            type: "simple",
            placeholder: "Filtra proveïdor",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Concepte",
          name: "concepte",
          filter: {
            type: "simple",
            placeholder: "Filtra concepte",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Import",
          name: "import",
          filter: {
            type: "simple",
            placeholder: "Filtra import",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Client",
          name: "cliente",
          filter: {
            type: "simple",
            placeholder: "Filtra client",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Projecte",
          name: "proyecto",
          filter: {
            type: "simple",
            placeholder: "Filtra projecte",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Accions",
          name: "acciones",
          row_text_alignment: "text-center",
        },
      ],
      classes: {
        cell: {
          "align-middle": true,
        },
      },
      config: {
        card_title: "Despeses",
        global_search: {
          placeholder: "Cerca",
        },
        per_page: 25,
        per_page_options: [25, 50, 100],
        num_of_visibile_pagination_buttons: 5,
      },
      nuevos: {
        gasto: {
          data_despesa: null,
          proveidor: null,
          concepte: null,
          import: null,
          id_projecte: null,
        },
      },
      clientes: [],
      proyectos: [],
      rango: null,
    };
  },
  computed: {
    maxFecha() {
      return this.toDateISOString(new Date());
    },
    minFechaDate() {
      return new Date(new Date().setFullYear(new Date().getFullYear() - 1));
    },
    minFecha() {
      return this.toDateISOString(this.minFechaDate);
    },
  },
  methods: {
    toDateISOString(date) {
      return date.toISOString().split("T")[0];
    },
    getData(rango) {
      const searchParams = rango ? { fecha_inicio: rango.inicio, fecha_fin: rango.fin } : {};
      this.rango = rango;

      this.$http.get(`api/despeses?${new URLSearchParams(searchParams)}`)
        .then(response => {
          if (response.status == 200) {
            this.rows = response.data.map(row => ({
              ...row,
              data_despesa_format: this.formatearFecha(row.data_despesa),
              data_despesa_cell: `${row.data_despesa} ${this.formatearFecha(row.data_despesa)}`,
            }));

            this.$toast.clear();
          }
        });

      this.$http.get("api/projectes?activos&order=cliente").then((response) => {
        this.proyectos = response.data;
      });
    },
    getRowId(id, rows) {
      return rows.find((element) => {
        return element.id == id;
      });
    },
    getMinFecha(fecha) {
      return new Date(this.minFecha).getTime() <= new Date(fecha).getTime() ? this.minFecha : "";
    },
    crearMultiple() {
      this.loading.creacionMultiple = true;

      this.$http
        .post("api/despeses", this.nuevos.gasto)
        .then((response) => {
          this.loading.creacionMultiple = false;

          this.$nextTick(() => {
            if (response.status == 201) {
              this.cerrarCreacion();
              $(this.$refs.autofocusCreacionMultiple).trigger("focus");

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Despesa creada correctament.` });

              if (this.rango?.inicio && response.data.data_despesa < this.rango.inicio) return;
              if (this.rango?.fin && response.data.data_despesa > this.rango.fin) return;

              this.rows.push({
                ...response.data,
                data_despesa_format: this.formatearFecha(response.data.data_despesa),
                data_despesa_cell: `${response.data.data_despesa} ${this.formatearFecha(response.data.data_despesa)}`,
              });
            }
          });
        })
        .catch((error) => {
          this.loading.creacionMultiple = false;
        });
    },
    editar(id) {
      this.loading.edicion = true;

      this.$http
        .put(`api/despeses/${id}`, this.getRowId(id, this.rowsBuffer))
        .then((response) => {
          this.loading.edicion = false;

          this.$nextTick(() => {
            if (response.status == 200) {
              this.$refs[`modalEdicion${id}`].cerrar();
              this.getRowId(id, this.rowsBuffer).proyecto = response.data.proyecto;
              this.getRowId(id, this.rowsBuffer).cliente = response.data.cliente;
              this.getRowId(id, this.rowsBuffer).data_despesa_format = this.formatearFecha(response.data.data_despesa);
              this.getRowId(id, this.rowsBuffer).data_despesa_cell = `${response.data.data_despesa} ${this.formatearFecha(response.data.data_despesa)}`;

              if ((this.rango?.inicio && response.data.data_despesa < this.rango.inicio) || (this.rango?.fin && response.data.data_despesa > this.rango.fin)) {
                this.rows = this.rows.filter(row => row.id != id);
              } else {
                this.rows = structuredClone(this.rowsBuffer);
              }

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Despesa editada correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.edicion = false;
        });
    },
    eliminar(id) {
      this.loading.eliminacion = true;

      this.$http
        .delete(`api/despeses/${id}`)
        .then((response) => {
          this.loading.eliminacion = false;

          this.$nextTick(function () {
            this.$refs[`modalEliminacion${id}`].cerrar();

            if (response.status == 200) {
              const found = this.rows.find((element) => element.id == id);
              found.eliminado = true;

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Despesa eliminada correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.eliminacion = false;
        });
    },
    abrirModal(autofocus) {
      $(this.$refs[autofocus]).trigger("focus");
    },
    cerrarCreacion() {
      this.nuevos.gasto.data_despesa = null;
      this.nuevos.gasto.proveidor = null;
      this.nuevos.gasto.concepte = null;
      this.nuevos.gasto.import = null;
      this.nuevos.gasto.id_projecte = null;
    },
    cerrarEdicion() {
      this.rowsBuffer = structuredClone(this.rows);
    },
    cerrarEliminacion() {
      this.rows = this.rows.filter(function (item) {
        return item.eliminado != true;
      });
    },
    exportarTablaPrevio() {
      this.exportarTabla(this.$route.name, this.$refs.tabla);
    },
    exportarBolcatPrevio() {
      this.exportarBolcat(this.$route.name, this.$refs.tabla);
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    rows(value) {
      this.rowsBuffer = structuredClone(value);
    },
  },
};
</script>